import { render, staticRenderFns } from "./board_metric_config.vue?vue&type=template&id=21f5708a&scoped=true"
import script from "./board_metric_config.vue?vue&type=script&lang=js"
export * from "./board_metric_config.vue?vue&type=script&lang=js"
import style0 from "./board_metric_config.vue?vue&type=style&index=0&id=21f5708a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f5708a",
  null
  
)

export default component.exports